/* @flow */

import React from 'react';
import PropTypes from 'prop-types';
import BaseIndicator from './BaseIndicator';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { VideoOff } from 'assets/images';
import { useTheme } from '@mui/styles';

/**
 * React {@code Component} for showing an audio muted icon with a tooltip.
 *
 * @returns {Component}
 */
const VideoMutedIndicator = ({ tooltipPosition }) => {
  const theme = useTheme();

  return (
    <BaseIndicator
      icon={VideoOff}
      iconColor={theme.palette.iconError}
      iconId="camera-disabled"
      iconSize={12}
      id="videoMuted"
      tooltipKey="videothumbnail.mute"
      tooltipPosition={tooltipPosition}
    />
  );
};

export default React.memo(withBoundary(VideoMutedIndicator));
VideoMutedIndicator.propTypes = {
  tooltipPosition: PropTypes.string
};
